import script from "./NextTaskFollowupModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NextTaskFollowupModal.vue?vue&type=script&setup=true&lang=ts"

import "./NextTaskFollowupModal.vue?vue&type=style&index=0&id=aced47fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aced47fc"]])

export default __exports__